export default __webpack_public_path__ + "static/media/SCANIA_CUIDADO DE AUTOBUSES EN CONTINGENCIA.52f681e1.pdf";